import { ReactComponent as Linkedin } from "../assets/icons/linkedin.svg";
import { ReactComponent as Github } from "../assets/icons/github.svg";
import { ReactComponent as Twitter } from "../assets/icons/twitter.svg";
import { ReactComponent as Email } from "../assets/icons/email.svg";
import { ReactComponent as AppStore } from "../assets/icons/apple.svg";
import { ReactComponent as PlayStore } from "../assets/icons/playstore.svg";

export const social = [
  {
    name: "Github",
    url: "https://github.com/mertcankose",
    icon: <Github width="28" height="28" />,
  },
  {
    name: "Linkedin",
    url: "https://www.linkedin.com/in/mertcankose-/",
    icon: <Linkedin width="28" height="28" />,
  },
  {
    name: "Email",
    url: "mailto:mertcankose142@gmail.com",
    icon: <Email width="28" height="28" />,
  },
  {
    name: "App Store",
    url: "https://apps.apple.com/tr/developer/mertcan-kose/id1714780859",
    icon: <AppStore width="28" height="28" />,
  },
  {
    name: "Play Store",
    url: "https://play.google.com/store/apps/developer?id=Mertcan+K%C3%B6se&hl=en_NZ",
    icon: <PlayStore width="28" height="28" />,
  },
];
